import { useState, createContext } from 'react';

const appContext = createContext();

//Contex Provider used to encapsulate only the components that needs the state in this context
export const PaysaProvider = ({children})=>{

    const [userInfoData, setUserInfoData] = useState('');

    //Increase counter
    const increment = (Data) => {
        return setUserInfoData(Data);
    }

    // //Decrease counter
    // const decrement = () => {
    //     return setCounter(counter - 1);
    // }


    return (
        <appContext.Provider value={{userInfoData, increment}}>
            {children}
        </appContext.Provider>
    )
}

export default appContext;